import React, { useEffect, useState } from 'react';
import ExportForm from '@app/components/apps/Export/ExportForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { Col, Row } from 'antd';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

const CreateExport: React.FC = () => {
  const [currentBreadcrumbName, setCurrentBreadcrumbName] = useState<string>('Add Pre-Clearance Category');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const expType = localStorage.getItem('exportType');
  const exportPath = expType === 'DRUG' ? '/export/feed-and-drugs' : '/export/normal';

  const routes = [
    {
      path: exportPath,
      breadcrumbName: 'Export',
    },
    {
      path: '/add-export',
      breadcrumbName: currentBreadcrumbName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumbName, expType]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ExportForm
            type="create"
            setCurrentBreadcrumName={setCurrentBreadcrumbName}
            pageTitle={'Create Export'}
            editable={true}
            id={null}
          />
        </Col>
      </Row>
    </>
  );
};

export default CreateExport;
